export const LOGOUT_USER = "logout-user";
export const LOGIN_USER = "login-user";
export const LOGIN_USER_SUCCESS = "login-user-success";
export const LOGIN_USER_ERROR = "login-user-error";
export const LOGIN_STATE_ACTION = "login-state-action";
export const USERNAME_CHANGED = "username_changed";
export const PASSWORD_CHANGED = "password_changed";
export const FORGOT_PASSWORD_CHANGED = "forgot_password_changed";


// WEBPACK FOOTER //
// ./src/actions/auth/types.ts